import { fetchWrapper } from ".";

export const getAnalytics = headers => fetchWrapper("GET", "/analytics", undefined, {}, headers);
